
function contestCountdown($time, $hasSeconds, $tz ){
	var steper = 1000,
		contest_second = 1000,
        contest_minute = contest_second * 60,
        contest_hour   = contest_minute * 60,
        contest_day    = contest_hour * 24;
    var dayStateUpdated = false;
    var _countDown = new Date($time).getTime();
    

    var x = setInterval(function() {
        var _now = new Date(new Date().toLocaleString('en', {timeZone: $tz}) ).getTime(),
            _distance = _countDown - _now;
        var next_day    = Math.floor( _distance / contest_day );
        var next_hour   = Math.floor( (_distance % contest_day ) / contest_hour );
        var next_minute = Math.floor((_distance % contest_hour) / contest_minute);
        var next_second = Math.floor((_distance % contest_minute) / contest_second);      

         if (next_day < 0 && next_hour < 0 && next_minute < 0 && next_second < 0) {
             clearInterval(x);
        }  

        
        if ($('.counter-group-days .counter-group-value').length) {
        	$('.counter-group-days .counter-group-value').each(function(){
                if(next_day < 0 ){
                  $(this).text(0);
                } else{
                    $(this).text(next_day);
                }
        	    
        	});
        }
        if ($('.counter-group-hours .counter-group-value').length) {
        	$('.counter-group-hours .counter-group-value').each(function(){
                 if(next_hour < 0 ){
                    next_hour =0 ;
                } 
        	 	$(this).text(next_hour);
        	});
        }
        if ( $('.counter-group-minutes .counter-group-value').length ) {
         	$('.counter-group-minutes .counter-group-value').each(function(){   
                 if(next_minute < 0 ){
                    next_minute =0 ;
                } 

        	    $(this).text(next_minute);
            });
        }
        if ($('.counter-group-seconds .counter-group-value').length) {
        	$('.counter-group-seconds .counter-group-value').each(function(){
                  if(next_second < 0 ){
                    next_minute =0 ;
                } 
        		$(this).text(next_second);
        	});
        }
        if(!dayStateUpdated){
            if ( next_day === 0  ) {
            	dayStateUpdated =true;
            	$('.counter-group-days').hide();
            	$('.counter-group-seconds').show();            	
            }else{
            	$('.counter-group-days').show();
            	$('.counter-group-seconds').hide();            	
            }
        }
        if (next_day === 0 && next_hour === 0 && next_minute === 0 && next_second === 0) {
            clearInterval(x);
            window.location.reload();
        }

       
    }, steper);
}